import { render, staticRenderFns } from "./ReactivationCampaigns.vue?vue&type=template&id=85646a58&scoped=true&"
import script from "./ReactivationCampaigns.vue?vue&type=script&lang=ts&"
export * from "./ReactivationCampaigns.vue?vue&type=script&lang=ts&"
import style0 from "./ReactivationCampaigns.vue?vue&type=style&index=0&id=85646a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85646a58",
  null
  
)

export default component.exports